import React, { useEffect } from 'react';
import { connect } from '../../react-redux';
import { bool, node, func } from 'prop-types';
import { getFeatures } from '../../api/features';
import { QuizzesSpinner as Spinner } from '../shared/spinner/Spinner';
import { Card } from '../shared/Card';
export var ApiFeatureFlagInitializerComponent = function ApiFeatureFlagInitializerComponent(props) {
  useEffect(function () {
    !props.loadedApiFeatures && props.getFeatures();
  }, []);
  return props.loadedApiFeatures ? props.children : /*#__PURE__*/React.createElement(Card, {
    wrapped: true
  }, /*#__PURE__*/React.createElement(Spinner, null));
};
ApiFeatureFlagInitializerComponent.propTypes = {
  children: node.isRequired,
  getFeatures: func.isRequired,
  loadedApiFeatures: bool
};
ApiFeatureFlagInitializerComponent.defaultProps = {
  loadedApiFeatures: false
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    loadedApiFeatures: state.getIn(['ui', 'loadedApiFeatures']) || ownProps.loadedApiFeatures
  };
};
var mapDispatchToProps = {
  getFeatures: getFeatures
};
export var ApiFeatureFlagInitializer = connect(mapStateToProps, mapDispatchToProps)(ApiFeatureFlagInitializerComponent);